import controller from './pay-by-bill.controller';

export default {
  controller,
  template: require('./pay-by-bill.html')
};



// WEBPACK FOOTER //
// src/app/buy/pay-by-bill/pay-by-bill.component.ts